import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import TradeEntryForm from './TradeEntryForm';

const EditSingleTrade = ({
  open,
  trade,
  userID,
  tradeAccountID,
  onClose,
  onUpdated,
}) => {
  if (!trade) return null;

  return (
    <Dialog
      visible={open}
      header="Edit Trade"
      style={{ width: '60vw' }}
      modal
      onHide={onClose}
    >
      <MDBox p={2}>
        <TradeEntryForm
          userID={userID}
          tradeAccountID={tradeAccountID}
          defaultValues={trade}
          isEdit
          onTradeSubmit={() => {
            onUpdated?.();
            onClose();
          }}
          setIsFormOpen={() => {}}
        />

        <MDBox mt={2} display="flex" justifyContent="flex-end">
          <MDButton color="error" variant="outlined" onClick={onClose}>
            Cancel
          </MDButton>
        </MDBox>
      </MDBox>
    </Dialog>
  );
};

export default EditSingleTrade;
